(function() {
  // Solo escritorio
  if (window.innerWidth < 750) return;

  function initZoom() {
    const containers = document.querySelectorAll('.product-media-container--image:not(.dialog-zoomed-gallery *)');

    containers.forEach(container => {
      // Evitar múltiples inicializaciones
      if (container.dataset.zoomInitialized) return;
      container.dataset.zoomInitialized = 'true';

      const img = container.querySelector('img');
      if (!img) return;

      // Estado del zoom
      let isZoomed = false;

      // Factor de ampliación (2x o el que prefieras)
      const zoomFactor = 2.5;

      // Activar zoom
      function activateZoom(e) {
        e.stopPropagation();
        e.preventDefault();

        if (isZoomed) return; // Ya está en zoom, solo mover

        isZoomed = true;
        container.classList.add('zoom-active');
        
        // Aplicar zoom inmediatamente en la posición actual del cursor
        const rect = container.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        moveZoom(mouseX, mouseY);
      }

      // Desactivar zoom
      function deactivateZoom() {
        if (!isZoomed) return;
        isZoomed = false;
        container.classList.remove('zoom-active');
        img.style.transform = 'scale(1)';
      }

      // Calcular y aplicar el desplazamiento según la posición del mouse
      function moveZoom(mouseX, mouseY) {
        if (!isZoomed) return;

        const rect = container.getBoundingClientRect();
        const containerWidth = rect.width;
        const containerHeight = rect.height;

        // Calcular posición relativa del cursor (0 a 1)
        const relX = mouseX / containerWidth;
        const relY = mouseY / containerHeight;

        // Calcular el desplazamiento necesario
        // La imagen ampliada se desplaza en dirección opuesta al cursor
        const moveX = relX * (zoomFactor - 1) * 150;
        const moveY = relY * (zoomFactor - 1) * 150;

        // Aplicar transformación
        img.style.transformOrigin = `${relX * 100}% ${relY * 100}%`;
        img.style.transform = `scale(${zoomFactor})`;
      }

      // Manejador de movimiento del ratón
      function onMouseMove(e) {
        const rect = container.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        // Si está en zoom, actualizar la vista
        if (isZoomed) {
          moveZoom(mouseX, mouseY);
        }
      }

      // Manejador de salida del ratón
      function onMouseLeave(e) {
        // Verificar que realmente salió del contenedor
        const rect = container.getBoundingClientRect();
        const x = e.clientX;
        const y = e.clientY;
        
        if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
          deactivateZoom();
        }
      }

      // Event listeners
      container.addEventListener('click', activateZoom, true);
      container.addEventListener('mousemove', onMouseMove);
      container.addEventListener('mouseleave', onMouseLeave);

      // Desactivar zoom con tecla ESC
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isZoomed) {
          deactivateZoom();
        }
      });
    });
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoom);
  } else {
    initZoom();
  }

  // Re-ejecutar si hay cambios dinámicos en la galería
  document.addEventListener('shopify:section:load', initZoom);
  document.addEventListener('variant:changed', () => setTimeout(initZoom, 100));
})();